import {Component, inject, Input} from '@angular/core';
import {DropdownsComponent} from "./dropdowns/dropdowns.component";
import {TranslationService} from '../services/translation/translation.service';

@Component({
  selector: 'af-header',
  imports: [
    DropdownsComponent
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  protected readonly translationService = inject(TranslationService);
  @Input() title: string = '';

}
